/**
 * Công thức thuyết minh chi dự phòng NS
 */
export default {
    RegularInvest: 1,
    Regular: 2,
    Before: 3,
    Setting: 4
  };